import { Outlet } from 'react-router'

const FuelInventoryLayout = () => {
  return (
    <Outlet />
  )
}

export default FuelInventoryLayout
